import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  classes: [],
};

export const classSlice = createSlice({
  name: "classes",
  initialState,

  reducers: {
    setClasses: (state, action) => {
      state.classes = action.payload;
    },
    removeClasses: (state) => {
      state.classes = [];
    },
  },
});

export const { setClasses, removeClasses } =
  classSlice.actions;

export default classSlice.reducer;
